import React from 'react';
import styles from './pi-title.module.scss';
import classNames from 'classnames';

type PiTitleProps = {
    text: string;
    additionalClassName?: string;
};
export const PiTitle = ({ text, additionalClassName }: PiTitleProps) => {
    return <h1 className={classNames(styles.piTitleContainer, additionalClassName)}>{text}</h1>;
};
